import { Injectable } from '@angular/core';
import { AcessoService } from 'src/app/service/acesso/acesso.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';


@Injectable({
  providedIn: 'root'
})
export class GrupoBeneficioService {
  localStorage: LocalStorage;
  url_acesso:string;
  headers = new HttpHeaders();
  cabecalho = new HttpHeaders();
  filial: string;
  codTarefa = "000000000";
  tpProcessamento = "EM";

  constructor(private http: HttpClient, private acesso: AcessoService ) {
    if (localStorage.getItem("util") != null) {
      this.localStorage = JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem("util")));
      this.cabecalho = this.headers.append('sessao', this.localStorage.Sessao);
      this.filial = this.localStorage.FilialAtual.toString();
      this.url_acesso = this.acesso.validarUrl();
    }
   }
   
   listarGrupos() {
    return this.http.get(`${this.url_acesso}beneficioscombogrupo/${this.filial}/${this.tpProcessamento}/${this.filial}`,{headers:this.cabecalho});
   }

   salvarGrupo(dados) {
    return this.http.put(`${this.url_acesso}beneficiosgrupos/${this.filial}/${this.tpProcessamento}/${this.filial}`, dados,{headers:this.cabecalho});
   }

   excluirGrupo(codigoGrupo) {
    return this.http.delete(this.url_acesso + `beneficio/deletegrupo/0000000/EM/${this.filial}/${codigoGrupo}`,{headers:this.cabecalho});
  }
  
}
